<template>
    <div></div>
</template>

<script>
export default {
    name: "PrometCreate"
}
</script>

<style scoped>

</style>